import { render, staticRenderFns } from "./reportFeeDetailOwner.vue?vue&type=template&id=246ecfdd&scoped=true"
import script from "./reportFeeDetailOwner.vue?vue&type=script&lang=js"
export * from "./reportFeeDetailOwner.vue?vue&type=script&lang=js"
import style0 from "./reportFeeDetailOwner.vue?vue&type=style&index=0&id=246ecfdd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246ecfdd",
  null
  
)

export default component.exports